import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18LockB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M8.911 4.75c1.689 0 3.069 1.395 3.162 3.153l-.001.001h.316c.338 0 .612.275.612.613v4.406a.61.61 0 0 1-.612.612H5.612A.61.61 0 0 1 5 12.923V8.517c0-.338.274-.612.612-.612l.137-.001C5.843 6.145 7.223 4.75 8.911 4.75m0 1.056c-1.136 0-2.068.923-2.16 2.098h4.32c-.091-1.175-1.023-2.098-2.16-2.098"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18LockB$1 = Svg18LockB;

export { Svg18LockB$1 as default };
